/**
 * @type {LanguagesShort[]}
 */
export const LanguagesShort = ['de', 'en', 'es'];

/**
 * @type {LanguagesLong[]}
 */
export const LanguagesLong = ['de-DE', 'en-US', 'es-ES'];
